import { render, staticRenderFns } from "./vNotice.vue?vue&type=template&id=23073540&"
import script from "./vNotice.vue?vue&type=script&lang=js&"
export * from "./vNotice.vue?vue&type=script&lang=js&"
import style0 from "./vNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports